import { createFileRoute } from "@tanstack/react-router"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { ProfilePage } from "@/features/shell/ProfilePage"

export const Route = createFileRoute("/_app/profil")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(childrenQueryOptions)
  },
  component: ProfilePage,
})
